<template>
  <div>
    <div class="list-group list-group-flush">
      <div
        class="list-group-item d-flex mb-1 align-items-center"
        v-for="gn in genes"
        :key="gn.olab_id"
      >
        <div v-if="selectedCart && !cartIsFull" class="col-1 m-auto">
          <button
            type="button"
            class="btn btn-info"
            data-toggle="modal"
            data-target="#selectAddGene"
            v-on:click="registerGene(gn)"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="plus" />
          </button>
        </div>
        <div
          v-else-if="
            enablePackageAdd && notInPackage(gn, selectedPackage.comps)
          "
          class="col-1 m-auto"
        >
          <button
            type="button"
            class="btn btn-info"
            v-on:click="addToPackageComps(gn)"
          >
            <font-awesome-icon icon="plus" />
          </button>
        </div>
        <div v-else-if="selectedGene == gn && saveStatus" class="col-1 m-auto">
          <button type="button" class="btn btn-info">
            <span
              class="spinner-border spinner-border-sm text-light"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </span>
          </button>
        </div>
        <div v-else class="col-1 m-auto">
          <!-- NOP -->
        </div>
        <div v-if="selectedGene != null" class="modal fade" id="selectAddGene">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  OLAB ID:
                  <span class="text-dark">{{ selectedGene.olab_id }}</span>
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <!-- .modal-header -->
              <div class="modal-body">
                <div class="text-wrap">
                  <span v-if="selectedGene.name">
                    <span class="font-italic mr-1">Name:</span>
                    <span class="h5 text-dark mr-5">{{
                      selectedGene.name
                    }}</span>
                  </span>
                  <span v-if="selectedGene.synonym_name1">
                    <span class="font-italic mr-1">Synonym Name:</span>
                    <span
                      v-if="selectedGene.synonym_name1"
                      class="h5 text-dark"
                      >{{ selectedGene.synonym_name1 }}</span
                    >
                    <span v-if="selectedGene.synonym_name2" class="h5 text-dark"
                      >; {{ selectedGene.synonym_name2 }}</span
                    >
                    <span v-if="selectedGene.synonym_name3" class="h5 text-dark"
                      >; {{ selectedGene.synonym_name3 }}</span
                    >
                    <span v-if="selectedGene.synonym_name4" class="h5 text-dark"
                      >; {{ selectedGene.synonym_name4 }}</span
                    >
                    <span v-if="selectedGene.synonym_name5" class="h5 text-dark"
                      >; {{ selectedGene.synonym_name5 }}</span
                    >
                  </span>
                </div>
                <div v-if="selectedGene.b_number" class="py-1 text-wrap">
                  <span class="font-italic mr-1">B Number:</span>
                  <span class="h5 text-dark">{{ selectedGene.b_number }}</span>
                </div>
                <div v-if="selectedGene.product" class="py-1 text-wrap">
                  <span class="font-italic mr-1">Product:</span>
                  <span class="h5 text-dark">{{ selectedGene.product }}</span>
                </div>
                <div
                  v-if="selectedGene.locus_tag || selectedGene.old_locus_tag"
                  class="my-2 card"
                >
                  <div class="card-header text-dark">Locus Tag</div>
                  <div class="card-body text-wrap">
                    <span class="font-italic mr-1">Old:</span>
                    <span class="h5 text-dark">{{
                      selectedGene.old_locus_tag
                    }}</span>

                    <span class="font-italic ml-3 mr-1">New:</span>
                    <span class="h5 text-dark">{{
                      selectedGene.locus_tag
                    }}</span>
                  </div>
                  <!-- .card-body -->
                </div>
                <div class="my-2 card">
                  <div class="card-header text-dark">Description</div>
                  <div class="card-body">
                    <div class="py-1 small font-italic text-dark text-wrap">
                      {{ selectedGene.desc }}
                    </div>
                  </div>
                  <!-- .card-body -->
                </div>
                <!-- .card -->
                <div class="py-1">
                  <div class="card">
                    <div class="card-header text-dark">Sequence</div>
                    <div class="card-body">
                      <span class="font-italic mr-1">Type:</span>
                      <span class="h5 text-dark">{{
                        selectedGene.sequence.type
                      }}</span>
                      <div class="pt-2">
                        <span class="mr-1">Range:</span>
                        <span class="h5 font-italic text-dark"
                          >[ {{ selectedGene.sequence.from }},</span
                        >
                        <span class="h5 font-italic">..,</span>
                        <span class="h5 font-italic text-dark"
                          >{{ selectedGene.sequence.to }} ]</span
                        >
                        <span class="ml-5 mr-1">Strand:</span>
                        <span class="h5 font-italic text-dark">{{
                          selectedGene.sequence.comp | convertCompToStrand
                        }}</span>
                      </div>
                      <div class="py-2">
                        <span class="font-italic mr-1">Length:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.len
                        }}</span>
                      </div>
                      <div class="py-1">
                        <span class="font-italic mr-1"># A:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.num_a
                        }}</span>
                        <span class="ml-3 font-italic mr-1"># C:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.num_c
                        }}</span>
                        <span class="ml-3 font-italic mr-1"># G:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.num_g
                        }}</span>
                        <span class="ml-3 font-italic mr-1"># T:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.num_t
                        }}</span>
                      </div>

                      <div
                        class="py-2 small text-monospace text-dark text-wrap"
                      >
                        {{ selectedGene.sequence.seq }}
                      </div>
                    </div>
                    <!-- .card-body -->
                  </div>
                  <!-- .card -->
                </div>
                <div class="form-group">
                  <label class="form-control-label mt-2" for="useSeqAs"
                    >Use As:</label
                  >
                  <select
                    class="form-control"
                    id="useSeqAs"
                    v-model="selectedUseSeqAs"
                  >
                    <option disabled value="">Please select one</option>
                    <option value="gene">Gene</option>
                    <option value="promoter">Promoter</option>
                    <option value="terminator">Terminator</option>
                  </select>
                  <!-- <span>selected = {{selectedUseSeqAs}}</span> -->
                </div>
                <!-- .form-group -->
              </div>
              <!-- .modal-body -->
              <div class="modal-footer">
                <button
                  type="button"
                  v-bind:disabled="itemAddIsDisabled == true"
                  class="btn btn-primary"
                  data-dismiss="modal"
                  v-on:click="handleAddToComps(selectedGene, selectedUseSeqAs)"
                >
                  Add
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Back
                </button>
              </div>
              <!-- .modal-footer -->
            </div>
            <!-- .modal-content -->
          </div>
          <!-- .modal-dialog -->
        </div>
        <!-- .modal fade #selectAddGene -->

        <div class="col-7 mx-1">
          <OlabSequenceSVGGen
            :numA="gn.gene_stats.num_a"
            :numC="gn.gene_stats.num_c"
            :numG="gn.gene_stats.num_g"
            :numT="gn.gene_stats.num_t"
            :shortSeq="gn.gene_stats.short_seq"
            :len="gn.gene_stats.len"
          />
        </div>

        <div class="col text-wrap">
          <a
            class="h5 text-info"
            data-toggle="modal"
            href="#geneDetailInfo"
            v-on:click="registerGene(gn)"
            data-backdrop="static"
            data-keyboard="false"
            >{{ gn.olab_id }}</a
          >

          <div
            v-if="selectedGene != null"
            class="modal fade"
            id="geneDetailInfo"
          >
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    OLAB ID:
                    <span class="h5 text-dark">{{ selectedGene.olab_id }}</span>
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <!-- .modal-header -->
                <div class="modal-body">
                  <div class="text-wrap">
                    <span v-if="selectedGene.name">
                      <span class="font-italic mr-1">Name:</span>
                      <span class="h5 text-dark mr-5">{{
                        selectedGene.name
                      }}</span>
                    </span>
                    <span v-if="selectedGene.synonym_name1">
                      <span class="font-italic mr-1">Synonym Name:</span>
                      <span
                        v-if="selectedGene.synonym_name1"
                        class="h5 text-dark"
                        >{{ selectedGene.synonym_name1 }}</span
                      >
                      <span
                        v-if="selectedGene.synonym_name2"
                        class="h5 text-dark"
                        >; {{ selectedGene.synonym_name2 }}</span
                      >
                      <span
                        v-if="selectedGene.synonym_name3"
                        class="h5 text-dark"
                        >; {{ selectedGene.synonym_name3 }}</span
                      >
                      <span
                        v-if="selectedGene.synonym_name4"
                        class="h5 text-dark"
                        >; {{ selectedGene.synonym_name4 }}</span
                      >
                      <span
                        v-if="selectedGene.synonym_name5"
                        class="h5 text-dark"
                        >; {{ selectedGene.synonym_name5 }}</span
                      >
                    </span>
                  </div>
                  <div v-if="selectedGene.b_number" class="py-1 text-wrap">
                    <span class="font-italic mr-1">B Number:</span>
                    <span class="h5 text-dark">{{
                      selectedGene.b_number
                    }}</span>
                  </div>
                  <div v-if="selectedGene.product" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Product:</span>
                    <span class="h5 text-dark">{{ selectedGene.product }}</span>
                  </div>
                  <div
                    v-if="selectedGene.locus_tag || selectedGene.old_locus_tag"
                    class="my-2 card"
                  >
                    <div class="card-header text-dark">Locus Tag</div>
                    <div class="card-body text-wrap">
                      <span class="font-italic mr-1">Old:</span>
                      <span class="h5 text-dark">{{
                        selectedGene.old_locus_tag
                      }}</span>

                      <span class="font-italic ml-3 mr-1">New:</span>
                      <span class="h5 text-dark">{{
                        selectedGene.locus_tag
                      }}</span>
                    </div>
                    <!-- .card-body -->
                  </div>
                  <div class="my-2 card">
                    <div class="card-header text-dark">Description</div>
                    <div class="card-body">
                      <div class="py-1 small font-italic text-dark text-wrap">
                        {{ selectedGene.desc }}
                      </div>
                    </div>
                    <!-- .card-body -->
                  </div>
                  <!-- .card -->
                  <div v-if="selectedGene.sequence != null" class="card">
                    <div class="card-header text-dark">Sequence</div>
                    <div class="card-body">
                      <span class="font-italic mr-1">Type:</span>
                      <span class="h5 text-dark">{{
                        selectedGene.sequence.type
                      }}</span>
                      <div class="pt-2">
                        <span class="mr-1">Range:</span>
                        <span class="h5 font-italic text-dark"
                          >[ {{ selectedGene.sequence.from }},</span
                        >
                        <span class="h5 font-italic">..,</span>
                        <span class="h5 font-italic text-dark"
                          >{{ selectedGene.sequence.to }} ]</span
                        >
                        <span class="ml-5 mr-1">Strand:</span>
                        <span class="h5 font-italic text-dark">{{
                          selectedGene.sequence.comp | convertCompToStrand
                        }}</span>
                      </div>
                      <div class="py-2">
                        <span class="font-italic mr-1">Length:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.len
                        }}</span>
                      </div>
                      <div class="py-1">
                        <span class="font-italic mr-1"># A:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.num_a
                        }}</span>
                        <span class="ml-3 font-italic mr-1"># C:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.num_c
                        }}</span>
                        <span class="ml-3 font-italic mr-1"># G:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.num_g
                        }}</span>
                        <span class="ml-3 font-italic mr-1"># T:</span>
                        <span class="h5 text-dark">{{
                          selectedGene.gene_stats.num_t
                        }}</span>
                      </div>

                      <div
                        class="py-2 small text-monospace text-dark text-wrap"
                      >
                        {{ selectedGene.sequence.seq }}
                      </div>
                      <!-- <img class="card-img-bottom img-fluid" v-bind:alt="selectedGene.name" v-bind:src="printGeneImageLink"> -->
                    </div>
                    <!-- .card-body -->
                  </div>
                  <!-- .card -->
                </div>
                <!-- .modal-body -->
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
                <!-- .modal-footer -->
              </div>
              <!-- .modal-content -->
            </div>
            <!-- .modal-dialog .modal-lg-->
          </div>
          <!-- .modal fade #geneDetailInfo -->

          <div class="h5 mt-2">
            <span v-if="gn.name" class="mr-2">{{ gn.name }}</span>
            <span v-if="gn.synonym_name1">{{ gn.synonym_name1 }}</span>
            <span v-if="gn.synonym_name2">; {{ gn.synonym_name2 }}</span>
            <span v-if="gn.synonym_name3">; {{ gn.synonym_name3 }}</span>
            <span v-if="gn.synonym_name4">; {{ gn.synonym_name4 }}</span>
            <span v-if="gn.synonym_name5">; {{ gn.synonym_name5 }}</span>
          </div>
          <div class="h5 text-truncate">
            <span v-if="gn.old_locus_tag" class="mr-3">{{
              gn.old_locus_tag
            }}</span>
            <span v-if="gn.locus_tag" class="mr-3">{{ gn.locus_tag }}</span>
            <span v-if="gn.b_number">{{ gn.b_number }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import OlabSequenceSVGGen from "@/components/OlabSequenceSVGGen";
import { OlabGene } from "../olab/olabgene.js";
import { OlabUtils } from "../olab/olabutils.js";

export default {
  name: "compdbgenelist",
  data: function() {
    return {
      selectedGene: null,
      selectedUseSeqAs: "",
      gene: new OlabGene()
    };
  },
  props: [
    "user",
    "genes",
    "saveStatus",
    "error",
    "selectedType",
    "selectedCart",
    "selectedPackage",
    "cartIsFull",
    "packageIsFull"
  ],
  components: {
    FontAwesomeIcon,
    OlabSequenceSVGGen
  },
  computed: {
    enablePackageAdd: function() {
      let pkgAddOK =
        !this.selectedCart &&
        this.selectedPackage &&
        this.selectedPackage.package_seq_type == "genome" &&
        !this.packageIsFull &&
        this.selectedType === "genome";
      return pkgAddOK;
    },
    itemAddIsDisabled: function() {
      if (!this.selectedGene || this.selectedUseSeqAs === "") {
        return true;
      }
      return false;
    }
  },
  filters: {
    convertCompToStrand: function(value) {
      // console.log("value = " + value + ", (value == true) = " +  (value == true));
      return value == "true" ? "-" : "+";
    }
  },
  methods: {
    notInPackage(gn, comps) {
      let result = true;
      OlabUtils.infoLog("gn.olab_id = " + gn.olab_id);
      OlabUtils.infoLog("comps.length = " + comps.length);
      comps.forEach(comp => {
        if (gn.olab_id == comp.olab_id) {
          OlabUtils.infoLog("gn == comp = " + (gn == comp));
          result = false;
        }
      });
      OlabUtils.infoLog("**** result = " + result);
      return result;
    },
    registerGene: function(gn) {
      this.selectedGene = gn;
      this.selectedUseSeqAs = "";
      // OlabUtils.infoLog("registerGene: gene = " + gn);
      this.gene.set(gn);
    },
    addToPackageComps: function(gn) {
      OlabUtils.infoLog("addToPackageComps: gene = " + gn);
      this.registerGene(gn);
      const useSeqAs = this.selectedPackage.package_type;
      OlabUtils.infoLog("addToPackageComps: useSeqAs = " + useSeqAs);
      this.handleAddToComps(gn, useSeqAs);
    },
    handleAddToComps: function(gn, useSeqAs) {
      OlabUtils.infoLog("handleAddToComps: gn = " + gn.olab_id);
      OlabUtils.infoLog("handleAddToComps: useSeqAs = " + useSeqAs);
      // Add the follow fields for cart's comps use
      gn.length = gn.gene_stats.len;
      gn.olab_type = "strain";

      this.$emit("doAddToComps", { item: gn, useSeqAs: useSeqAs });
    }
  }
};
</script>
